import * as accessLevel from './accessLevel/reducer'
import * as homePage from './homePage/reducer'
import * as projectPage from './projectPage/reducer'
import * as adminPage from './adminPage/reducer'


export default {
  accessLevel,
  homePage,
  projectPage,
  adminPage,
}
